export default __webpack_public_path__ + "static/media/Probe.3b97ec0a.svg";